import { useState } from "react";
import { format, startOfMonth, subMonths } from "date-fns";

import Layout from "@/components/layout/Layout";
import { CashFlowStatementHeader } from "@/components/finance/reports/cash-flow-details-new/Header";
import { BalanceSheetTable } from "@/components/finance/reports/balance-sheet/BalanceSheetTable";
import {
  useBalanceSheet,
  type ViewPeriod,
  type DisplayCurrency,
} from "@/hooks/finance/balance-sheet/useBalanceSheet";

// Header component accepts a broader ViewPeriod ('daily'|'weekly'|'monthly'|'quarterly').
// We only surface Monthly/Quarterly/Yearly and clamp anything else back to monthly.
type HeaderPeriod = "daily" | "weekly" | "monthly" | "quarterly";

export default function BalanceSheetPage() {
  const today = format(new Date(), "yyyy-MM-dd");
  const sixMonthsAgo = format(startOfMonth(subMonths(new Date(), 5)), "yyyy-MM-dd");

  const [dateFrom, setDateFrom] = useState(sixMonthsAgo);
  const [dateTo, setDateTo] = useState(today);
  const [viewPeriod, setViewPeriod] = useState<ViewPeriod>("monthly");
  const [displayCurrency, setDisplayCurrency] = useState<DisplayCurrency>("ETB");

  const { rows, periods, isLoading } = useBalanceSheet(
    dateFrom,
    dateTo,
    viewPeriod,
    displayCurrency,
  );

  return (
    <Layout>
      <div className="space-y-6 pb-12 animate-in fade-in duration-700">
        <CashFlowStatementHeader
          dateFrom={dateFrom}
          dateTo={dateTo}
          viewPeriod={viewPeriod as HeaderPeriod}
          displayCurrency={displayCurrency}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onViewPeriodChange={(v) => {
            if (v === "monthly" || v === "quarterly") setViewPeriod(v);
            else setViewPeriod("monthly");
          }}
          onDisplayCurrencyChange={setDisplayCurrency}
          title="Balance Sheet"
          badgeLabel="Snapshot"
        />

        <BalanceSheetTable
          rows={rows}
          periods={periods}
          isLoading={isLoading}
          displayCurrency={displayCurrency}
        />
      </div>
    </Layout>
  );
}
